import React, { useState, useEffect } from 'react';
import '../styles/CookieConsent.css';

const STORAGE_KEY = 'cookieConsent';

function CookieConsent({ onAccept }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
    if (onAccept) onAccept();
  };

  const handleDecline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-dialog">
      <p className="cookie-title">Micropincher</p>
      <p className="cookie-body">
        We use cookies to keep you logged in and to analyse web bugs and statistics of feature usage. See our{' '}
        <a href="/privacy" className="cookie-link">Privacy Policy</a> and{' '}
        <a href="/terms" className="cookie-link">Terms & Conditions</a>.
      </p>
      <div className="cookie-actions">
        <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
          Decline
        </button>
        <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
          Accept
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
